if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.prebookingPropertyName = 'properties[Internal Availability]';
      this.prebookingPropertyValue = '\u26A0 PREBOOKING ITEM';
      this.initPrebookingLineItemProperty();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButton.disabled = false;
      this.submitButton.removeAttribute('disabled');
      this.submitButton.removeAttribute('aria-disabled');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      const selectElement = this.form.querySelector('[name=id]');          
      const listItems = this.form.querySelectorAll("#variantList li");
      if(!listItems) return;      
      const optionDiv = this.form.querySelector('#variantList');
        listItems.forEach(item => {
          item.addEventListener("click", function(event) {      
            const value = this.getAttribute("data-value");          
            const variantPrice = this.getAttribute('data-price');            
            const variantQTY = this.getAttribute('data-inventory');           
            selectElement.value = value;               
            const closestList = event.target.parentElement.closest('.variantPick');                       
            const priceContainer = closestList.querySelector(".price-item--sale");   
            priceContainer.innerHTML = variantPrice;                     
            var variantMedia = this.getAttribute("data-variant-media");            
             this.closest('.card-wrapper').querySelector('.card__inner .featured-media').setAttribute("srcset", variantMedia);
          });
          
      }); 
    }

    initPrebookingLineItemProperty() {
      this.prebookingPropertyInput = this.form.querySelector('[data-prebooking-property]');
      this.variantIdInput = this.form.querySelector('[name=id]');
      const variantPicker = document.querySelector('variant-radios, variant-selects');
      const variantsJson = variantPicker ? variantPicker.querySelector('script[type="application/json"]') : null;

      if (!this.prebookingPropertyInput || !this.variantIdInput) return;

      try {
        this.prebookingVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
      } catch (error) {
        this.prebookingVariants = [];
      }

      try {
        this.prebookingVariantIds = JSON.parse(this.prebookingPropertyInput.dataset.prebookingVariantIds || '[]')
          .map((variantId) => Number(variantId));
      } catch (error) {
        this.prebookingVariantIds = [];
      }

      const updateProperty = () => this.updatePrebookingPropertyInput();

      this.variantIdInput.addEventListener('change', updateProperty);
      this.form.addEventListener('change', updateProperty);
      document.addEventListener('variant:change', updateProperty);
      document.addEventListener('shopify:section:load', updateProperty);

      updateProperty();
    }

    updatePrebookingPropertyInput() {
      if (!this.prebookingPropertyInput || !this.variantIdInput || !Array.isArray(this.prebookingVariants)) return;

      const selectedVariantId = Number(this.variantIdInput.value);
      const selectedVariant = this.prebookingVariants.find((variant) => Number(variant.id) === selectedVariantId);
      const isPrebooking = this.isSelectedVariantPrebooking(selectedVariantId, selectedVariant);

      if (isPrebooking) {
        this.prebookingPropertyInput.disabled = false;
        this.prebookingPropertyInput.value = this.prebookingPropertyValue;
      } else {
        this.prebookingPropertyInput.value = '';
        this.prebookingPropertyInput.disabled = true;
      }

      return isPrebooking;
    }

    isPrebookVariant(variant) {
      if (!variant) return false;

      return Number(variant.inventory_quantity) <= 0 && variant.inventory_policy === 'continue';
    }

    isSelectedVariantPrebooking(selectedVariantId, selectedVariant) {
      if (Array.isArray(this.prebookingVariantIds) && this.prebookingVariantIds.length > 0) {
        return this.prebookingVariantIds.includes(Number(selectedVariantId));
      }

      return this.isPrebookVariant(selectedVariant);
    }

    applyPrebookingPropertyToFormData(formData) {
      const isPrebooking = this.updatePrebookingPropertyInput();
      const selectedVariantId = this.variantIdInput ? this.variantIdInput.value : null;
      const selectedVariant = Array.isArray(this.prebookingVariants)
        ? this.prebookingVariants.find((variant) => Number(variant.id) === Number(selectedVariantId))
        : null;
      const buttonText = this.submitButton ? this.submitButton.textContent.trim() : '';

      formData.delete(this.prebookingPropertyName);
      if (isPrebooking) {
        formData.append(this.prebookingPropertyName, this.prebookingPropertyValue);
      }

      const formDataEntries = Object.fromEntries(formData.entries());

      console.log('PREBOOK PROPERTY DEBUG - selectedVariantId:', selectedVariantId);
      console.log('PREBOOK PROPERTY DEBUG - inventory_quantity:', selectedVariant ? selectedVariant.inventory_quantity : undefined);
      console.log('PREBOOK PROPERTY DEBUG - inventory_policy:', selectedVariant ? selectedVariant.inventory_policy : undefined);
      console.log('PREBOOK PROPERTY DEBUG - isPrebooking:', isPrebooking);
      console.log('PREBOOK PROPERTY DEBUG - button text:', buttonText);
      console.log('PREBOOK PROPERTY DEBUG - hidden input exists:', Boolean(this.prebookingPropertyInput));
      console.log('PREBOOK PROPERTY DEBUG - hidden input is inside form:', Boolean(this.prebookingPropertyInput && this.prebookingPropertyInput.form === this.form));
      console.log('PREBOOK PROPERTY DEBUG - hidden input disabled:', this.prebookingPropertyInput ? this.prebookingPropertyInput.disabled : null);
      console.log('PREBOOK PROPERTY DEBUG - hidden input value:', this.prebookingPropertyInput ? this.prebookingPropertyInput.value : null);
      console.log('PREBOOK PROPERTY DEBUG - final FormData:', Array.from(formData.entries()));
      console.log('PREBOOK PROPERTY DEBUG - final AJAX payload:', formDataEntries);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.submitButton.disabled = false;

      this.handleErrorMessage();

      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      this.applyPrebookingPropertyToFormData(formData);
      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('disabled');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
           setTimeout(function(){
         	giftCart();
          }, 1000); 
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function() {
//  CartJS.updateCart();
});


function giftCart() {
  const cartItems = document.querySelectorAll('tr.cart-item');
    cartItems.forEach(cartItem => {        
        const dataId = cartItem.getAttribute('data-id');
        const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);  
      if(!drawerFooter) return;
      const drawerFooterID = drawerFooter.getAttribute('data-id');
        if(drawerFooterID == dataId) {            
            drawerFooter.classList.add('Gift-Wrapper__hide'); 
        }
    });
}
